import { provideZoneChangeDetection } from '@angular/core';
/// <reference types="@angular/localize" />
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { MdsConfig } from '@maersk-global/mds-config';

// mds icons are dynamically imported from the assets folder
MdsConfig.iconsDynamicImportPath = `${location.protocol}//${location.host}/maersk_assets/`;

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), ...appConfig.providers],
});
